<template>
  <section class="local-lm-dashboard-menu">
    <b-menu-list>
      <b-menu>
        <b-menu-item
          icon="home"
          :label="$t('DashboardMenu.labelOrders')"
          tag="router-link"
          :to="{ name: 'Orders' }"
        />
        <b-menu-item
          icon="check-circle"
          :label="$t('DashboardMenu.labelAvailableOrders')"
          tag="router-link"
          :to="{ name: 'Available' }"
        />
        <b-menu-item
          icon="mailbox-up"
          :label="$t('DashboardMenu.labelDispatchOrders')"
          tag="router-link"
          :to="{ name: 'Dispatch' }"
        />
        <b-menu-item
          v-if="authorizeMainMenuItemAccess('Administration')"
          icon="settings"
          :label="$t('DashboardMenu.labelAdmin')"
          tag="router-link"
          :to="{ name: 'Admin' }"
        />
      </b-menu>
    </b-menu-list>
  </section>
</template>

<script>
import { services } from '@/services'

export default {
  name: 'DashboardMenu',
  methods: {
    authorizeMainMenuItemAccess (item) {
      return services.userService().authorizeMainMenuItemAccess(item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardMenu.vue